import { useCallback } from 'react'
import type { ShopMessageKey } from '../messages'
import type { ShopLocale } from '../shopLocale'
import type { TranslateParams } from './types'

type Params = {
  locale: ShopLocale
  t: (key: ShopMessageKey, params?: TranslateParams) => string
}

export const useShopFormatters = ({ locale, t }: Params) => {
  const formatCurrency = useCallback(
    (value: number, currency = 'EUR') =>
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(value),
    [locale],
  )

  const formatDateTime = useCallback(
    (value: string | null) => {
      if (!value) return t('common.never')
      const parsed = new Date(value)
      if (Number.isNaN(parsed.getTime())) return t('common.never')
      return new Intl.DateTimeFormat(locale, {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(parsed)
    },
    [locale, t],
  )

  return { formatCurrency, formatDateTime }
}
